<div class="page not-found">
	<div class="page-content content">
		<a href="/">
			<img src="{{ environment.cdn_base_url }}/assets-front/img/not-found.png" alt="Sorry, page not found">
		</a>
	</div>
</div>
